import angular from 'angular';

angular.module('cloudX').directive('cxUnpaidInvoiceBar', [
  function() {
    return {
      restrict: 'E',
      //replace: true,
      template: require('./unpaidInvoiceBar.html'),
      scope: true,
      link: function(scope, element, attrs) {
        scope.limit = Number(attrs['limit']) || -1; //Default no limit
      },
      controller: [
        '$scope',
        'invoicingSvc',
        function($scope, invoicingSvc) {
          $scope.data = invoicingSvc.getUnpaidInvoices();
          invoicingSvc.reloadUnpaidInvoices(10);
        },
      ],
    };
  },
]);
